import type { TWorkerState } from '@/types/state-types';

export default <TWorkerState> {
  workers: null
};
